import React from "react"
import "./Home.css"
import hero from "../pic/Profile-Picture.png"
import skill1 from "../pic/laravel.svg"
import skill2 from "../pic/node-js.svg"
import skill3 from "../pic/react.svg"
import { Typewriter } from "react-simple-typewriter"

const Home = () => {
  return (
    <>
      <section className='hero' id='home'>
        <div className='container f_flex top'>
          <div className='left top'>
            <h3>WELCOME TO MY WORLD</h3>
            <h1>
              Hi, I’m <span>Ibrahim Serhane</span>
            </h1>
            <h2>
              a
              <span>
                <Typewriter words={[" Professional Coder.", " Developer."]} loop cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
              </span>
            </h2>

            <p>I am a passionate, dedicated Web Developer. I am always committed to learning. During the past few years, I discovered my deep interest in programming, so I worked on different projects and different platforms, including mobile, software and web. I practiced a lot of programming languages, tools, and frameworks such as JavaScript, ReactJs / React Native, NodeJS, Laravel, .NET and WordPress. Follow best practices for each one of them. I have gathered knowledge about steps to deploying a website.</p>

            <div className='hero_btn d_flex'>
              <div className='col_1'>
                <h4>FIND WITH ME</h4>
                <div className='button'>
                  <button className='btn_shadow'>
                    <i className='fab fa-linkedin-in'></i>
                  </button>
                </div>
              </div>
              <div className='col_1'>
                <h4>BEST SKILL ON</h4>
                <button className='btn_shadow'>
                  <img src={skill1} alt='' />
                </button>
                <button className='btn_shadow'>
                  <img src={skill2} alt='' />
                </button>
                <button className='btn_shadow'>
                  <img src={skill3} alt='' />
                </button>
              </div>
            </div>
          </div>
          <div className='right'>
            <div className='right_img'>
              <img src={hero} alt='' />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
